module.exports = __webpack_public_path__ + "static/media/polaroid-4.87d66e62.png";